import { createContext, ReactNode, useReducer } from 'react'

import { getPostListsByArticleId } from './api/services'
import { Community, Post, Topic } from './interfaces/types'
import { CommunityActions, communityReducer } from './state/communityReducer'
import { PostActions, postReducer } from './state/postReducer'
import { TopicActions, topicReducer } from './state/topicReducer'

export type ReducerAction = {
  type: CommunityActions | TopicActions | PostActions
  payload?: any
}
export type State = {
  communitiesById: {
    [k: string]: Community
  }
  topicsById: {
    [k: string]: Topic
  }
  postsById: {
    [k: string]: Post
  }
}
export const initialState: State = {
  communitiesById: {},
  topicsById: {},
  postsById: {},
}

export type Context = {
  state: State
  dispatch: (action: ReducerAction) => void
  services: any
}
export const TogetherDataContext = createContext<Context>({} as Context)

function reducer(state: State, action: ReducerAction) {
  return [communityReducer, topicReducer, postReducer].reduce(
    (acc, nextReducer) => nextReducer(acc, action),
    state,
  )
}
export type Props = {
  children: ReactNode
}
export const TogetherDataContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const services = {
    getPostListsByArticleId,
  }
  return (
    <TogetherDataContext.Provider value={{ state, services, dispatch }}>
      {children}
    </TogetherDataContext.Provider>
  )
}

// export {CountProvider, useCount}
